import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

/**
 * FeatureRoleGuard - Protects routes based on a feature-scoped delegated role
 * (e.g. Task Delegate), in addition to app-wide Admin access.
 *
 * Usage:
 * <FeatureRoleGuard featureKey="task_management">
 *   <TaskDelegateOnlyPage />
 * </FeatureRoleGuard>
 */
const FeatureRoleGuard = ({ children, featureKey }) => {
  const user = authService.getCurrentUser();

  if (!user) {
    return <Navigate to="/login" />;
  }

  const hasAccess = user.role === 'admin' || (user.featureRoles || []).includes(featureKey);

  if (!hasAccess) {
    return <Navigate to="/access-denied" />;
  }

  return children;
};

export default FeatureRoleGuard;
